import {Injectable} from '@angular/core';
import {User} from '../model/GeneralModels';
import {environment} from '../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class AuthService {

  // helper: JwtHelperService;

  constructor() {
    // this.helper = new JwtHelperService();
    // const decodedToken = this.helper.decodeToken(myRawToken);
    // const expirationDate = this.helper.getTokenExpirationDate(myRawToken);
    // const isExpired = this.helper.isTokenExpired(myRawToken);
  }

  decode() {
    if (this.isAuthenticated()) {
      const token = atob(localStorage.getItem(environment.token));
      const array = token.split(':');
      return new User(array[0], array[1]);
    } else {
      return null;
    }
  }

  encode(username, role) {
    if (username && role) {
      localStorage.setItem(environment.token, btoa(username + ':' + role));
      return true;
    } else {
      return false;
    }
  }

  logout() {
    localStorage.removeItem(environment.token);
  }

  isAuthenticated() {
    if (localStorage.getItem(environment.token)) {
      return true;
    } else {
      return false;
    }
  }
}
